import { BreadcrumbGroup, BreadcrumbGroupProps } from '@amzn/awsui-components-core';
import React from 'react';
import BrowserHistory from '../utils/BrowserHistory';

class Breadcrumbs extends React.Component<{ items: BreadcrumbGroupProps.Item[] }> {
  public render() {
    const { items } = this.props;
    // const bItems = items.map((i, idx) => <BreadcrumbItem key={idx} text={i.text} href={i.href} onClick={this.navigate} />);
    return (
      <div className="details-breadcrumb">
        <BreadcrumbGroup items={items} ariaLabel="Breadcrumb navigation" onClick={this.navigate} />
      </div>
    );
  }

  private navigate = (e: any) => {
    e.preventDefault();
    BrowserHistory.push(e.detail.href);
  };
}

export default Breadcrumbs;
